<template>
	<section class="impact-section">
		<img class="water-mark" src="~@/assets/img/logo-water-mark.png" alt="logo water mark" />
		<div class="container">
			<div class="animation-container" v-if="desktop">
				<h2 class="fadeInUp animated delay-800">{{ $t('Impact.title') }}</h2>
				<div class="fadeInUp animated delay-1000">
					<p class="white">{{ $t('Impact.paragraph_1') }}</p>
					<p class="white">{{ $t('Impact.paragraph_2') }}</p>
				</div>
			</div>
			<div class="animation-container" v-else>
				<h2 class="fadeInUp" v-wow="{
						'animation-duration': '1s',
					}">{{ $t('Impact.title') }}</h2>
				<div
					class="fadeInUp"
					v-wow="{
						'animation-duration': '1s',
						'animation-delay': '0.3s',
					}"
				>
					<p class="white">{{ $t('Impact.paragraph_1') }}</p>
					<p class="white">{{ $t('Impact.paragraph_2') }}</p>
				</div>
			</div>
			<ul class="values">
				<ImpactItem v-for="(impact, index) in impacts" :key="index" :impact="impact" />
			</ul>
		</div>
	</section>
</template>

<script>
import ImpactItem from '../partials/ImpactItem.vue'
export default {
	name: 'Impact',
	components: { ImpactItem },
	computed: {
		impacts() {
			return this.$t('Impact.impacts')
		},
	},
	data() {
		return {
			desktop: true,
		}
	},
	created() {
		if (window.innerWidth < 768) {
			this.desktop = false
		}
	},
}
</script>

<style scoped lang="scss">
.impact-section {
	position: relative;
	padding: 55px 0 30px;
	background-color: $gray4Theme;
	color: $white;
}

.water-mark {
	position: absolute;
	right: -248px;
}

h2 {
	@extend %lato-black;
	font-weight: 900;
	text-align: center;
	text-transform: uppercase;
	letter-spacing: 3.2px;
	margin-bottom: 23px;
}

p {
	font-size: 17px;
	text-align: center;
	margin-bottom: 4px;
}

.values {
	@include flex-container(center);
	margin: 64px auto;
}

@include mobile {
	.impact-section {
		margin-top: 159px;
		padding-top: 200px;
	}
	.values {
		margin: 30px auto 0;
	}
}
</style>
